//
//
//
//
//
//
//
//
//
//

import VHeader from './components/Header'
import VDrawer from './components/Drawer'

export default {
  components: {
    VHeader,
    VDrawer,
  }
}
